// Route guard backed by Firebase Auth.
//
// Usage:
//   <ProtectedRoute><CosmicUserPortal /></ProtectedRoute>            // any signed-in user
//   <ProtectedRoute requireCoach redirectTo="/coach"><Dash/></ProtectedRoute>  // APC staff coach only
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const ProtectedRoute = ({ children, requireCoach = false, redirectTo = '/cosmic-login' }) => {
  const { isAuthenticated, isCoach, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '60vh',
          color: '#4f46e5',
        }}
      >
        Loading...
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={redirectTo} replace state={{ from: location.pathname }} />;
  }

  if (requireCoach && !isCoach) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
